import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Route} from '../../enum/route';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {selectAuthenticated, selectUserRoles} from '../../store/auth/selectors/auth.selectors';
import {selectUser, selectUserId} from '../../store/user/selectors/user.selectors';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {AuthState} from '../../store/auth/reducers/auth.reducer';
import {AuthService} from '../../services/auth/auth.service';
import {LocalStorageItem} from '../../enum/local-storage-item';
import {BehaviorSubject, map, Subject, takeUntil} from 'rxjs';
import {Roles} from '../../enum/roles';
import {ProposalTileSortParameter} from '../../enum/proposal-tile-sort-parameter';
import {FilterRole} from '../../enum/filter-role';
import {CompanyAppState} from '../../store/company/reducers/company.reducer';
import {selectMyCompany} from '../../store/company/selectors/company.selectors';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-main-layout-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {

  Route = Route;
  authenticated$ = this.authStore.select(selectAuthenticated);
  userId$ = this.userStore.select(selectUserId);
  user$ = this.userStore.select(selectUser);
  roles$ = this.userStore.select(selectUserRoles);
  userType$= this.userStore.select(selectUser).pipe(map(userPage => userPage.type));
  userIsBusinessAdmin$= this.userStore.select(selectUser).pipe(map(userPage => userPage.isBusinessAdmin));
  destroy$ = new Subject<void>();
  isCollapsed$ = new BehaviorSubject<boolean>(false);
  company$ = this.companyStore.select(selectMyCompany);

  Roles = Roles;

  constructor(public readonly authService: AuthService,
              public readonly translate: TranslateService,
              public readonly router: Router,
              private readonly authStore: Store<AuthState>,
              private readonly userStore: Store<UserAppState>,
              private readonly companyStore: Store<CompanyAppState>
  ) {
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.setNavbarCollapse();
    this.isCollapsed$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
          localStorage.setItem(LocalStorageItem.NAVBAR_COLLAPSED, String(value));
        }
      );
  }

  setNavbarCollapse() {
    const navbarCollapsed = localStorage.getItem(LocalStorageItem.NAVBAR_COLLAPSED);
    if (navbarCollapsed == String(true)) {
      this.isCollapsed$.next(true);
    } else if (navbarCollapsed == String(false)) {
      this.isCollapsed$.next(false);
    } else if (window.innerWidth < 1920) {
      this.isCollapsed$.next(true);
    }
  }

  redirectToNMS() {
    const windowUrl = window.location.hostname;

    if (windowUrl.includes("dev")) {
      window.open(environment.nmsDev, "_blank", "noopener")
    } else if (windowUrl.includes("int")) {
      window.open(environment.nmsInt, "_blank", "noopener")
    } else if (windowUrl.includes("sit")) {
      window.open(environment.nmsSit, "_blank", "noopener")
    } else if (windowUrl.includes("uat")) {
      window.open(environment.nmsUat, "_blank", "noopener")
    } else {
      window.open(environment.nmsProd)
    }
  }


  isActiveRoute(route: string): string {
    return  this.router.url.startsWith(`/${route}`) ? '-active' : '';
  }

  logout() {
    this.setLocalStorage();
    this.authService.logout();
  }

  toggleCollapse() {
    this.isCollapsed$.next(!this.isCollapsed$.value);
  }

  private setLocalStorage() {
    localStorage.setItem(LocalStorageItem.SORT_BY, ProposalTileSortParameter.CREATION_DATE);
    localStorage.setItem(LocalStorageItem.ASCENDING, 'true');
    localStorage.setItem(LocalStorageItem.NO_COVERAGE, 'false');
    localStorage.setItem(LocalStorageItem.LEAD_INSURER_NEEDED, 'false');
    localStorage.setItem(LocalStorageItem.FOLLOWING_INSURER_NEEDED, 'false');
    localStorage.setItem(LocalStorageItem.LIMIT_PRICE, 'false');
    localStorage.setItem(LocalStorageItem.SELECTED_ROLE, FilterRole.ALL);
    localStorage.setItem(LocalStorageItem.LINE_OF_BUSINESS, '');
  }
}
